import { render, staticRenderFns } from "./InsuranceStats.vue?vue&type=template&id=6611ecd4&scoped=true"
import script from "./InsuranceStats.vue?vue&type=script&lang=js"
export * from "./InsuranceStats.vue?vue&type=script&lang=js"
import style0 from "./InsuranceStats.vue?vue&type=style&index=0&id=6611ecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6611ecd4",
  null
  
)

/* custom blocks */
import block0 from "./InsuranceStats.vue?vue&type=custom&index=0&blockType=el-form-item&label=%E5%B9%B3%E5%8F%B0%EF%BC%9A"
if (typeof block0 === 'function') block0(component)

export default component.exports